/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivateVendorWorkspaceDto } from '../../models/activate-vendor-workspace-dto';
import { VendorWorkspaceDto } from '../../models/vendor-workspace-dto';

export interface VendorWorkspaceControllerActive$Params {
  id: string;
      body: ActivateVendorWorkspaceDto
}

export function vendorWorkspaceControllerActive(http: HttpClient, rootUrl: string, params: VendorWorkspaceControllerActive$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceControllerActive.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceDto>;
    })
  );
}

vendorWorkspaceControllerActive.PATH = '/api/vendorWorkspace/{id}/active';
